import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DataService } from '@shared/services/data.service';
import { Observable, of as ofObservable } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function catchResolverError<T>(
  router: Router,
  resolverObservable: Observable<T>,
  navigateTo = ['/error']
): Observable<T> {
  return resolverObservable.pipe(
    catchError(() => {
      router.navigate(Array.isArray(navigateTo) ? navigateTo : [navigateTo]);
      return ofObservable(null);
    })
  );
}

@Injectable({
  providedIn: 'root',
})
export class ErrorPageGuard {
  constructor(
    private dataService: DataService,
    private router: Router
  ) {}

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
    return this.dataService.getNavigationState().currentUrl !== '/' || this.router.parseUrl('/records');
  }
}
